/* eslint-disable react/prop-types */
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import separate from 'utils/separate';
import SoftBadge from 'components/SoftBadge';
import useModal from 'hooks/useModal';
import UpdateSettingModal from './UpdateSettingModal';

function createData(id, name, value, created_at, updated_at, operation) {
    return { id, name, value, created_at, updated_at, operation };
}

export default function SettingsTable({ data, setSettings }) {
    const [modals, updateModal, closeModal] = useModal({
        updateSetting: { state: false },
    });
    const closeUpdateSettingModal = () => closeModal("updateSetting");

    const rows = data.map(item => createData(
        item.id,
        item.name,
        item.value,
        new Date(item.created_at).toLocaleString("fa-IR"),
        new Date(item.updated_at).toLocaleString("fa-IR"),
        <SoftBadge variant="contained"
            onClick={() => updateModal("updateSetting", { state: true, item })}
            badgeContent="آپدیت"
            style={{ cursor: "pointer" }}
            color="secondary" size="xs" />
    ));

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>اسم</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>مقدار</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>آخرین آپدیت</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {rows.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell className="tablecell" style={fixTableCellWidth("150px")} align="left">{row.name}</TableCell>
                                <TableCell className="tablecell" style={fixTableCellWidth("150px")} align="left">{separate(row.value)}</TableCell>
                                <TableCell className="tablecell" style={fixTableCellWidth("150px")} align="left">{row.created_at}</TableCell>
                                <TableCell className="tablecell" style={fixTableCellWidth("150px")} align="left">{row.updated_at}</TableCell>
                                <TableCell className="tablecell" style={fixTableCellWidth("150px")} align="left">{row.operation}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {modals.updateSetting.state && <UpdateSettingModal modalInfo={modals.updateSetting} setSettings={setSettings} closeModal={closeUpdateSettingModal} />}
        </>
    );
}